export const config = {
	NODE_ENV: 'production',
	APP_URL: 'https://test.gis-solution.ro',
	API_URL: 'https://testapi-gisexplorer.gis-solution.ro/'
}
